import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../sections/HeroSection';
import TickerSection from '../sections/TickerSection';
import AboutSection from '../sections/AboutSection';
import SolutionsSection from '../sections/SolutionsSection';
import TrendsSection from '../sections/TrendsSection';
import InnovationSection from '../sections/InnovationSection';
import SustainabilitySection from '../sections/SustainabilitySection';
import MarketsSection from '../sections/MarketsSection';
import GallerySection from '../sections/GallerySection';
import WhySection from '../sections/WhySection';
import ContactSection from '../sections/ContactSection';
import Footer from '../components/Footer';
import { useAuraluxClientEffects } from '../hooks/useAuraluxClientEffects';

export default function Home() {
  useAuraluxClientEffects();

  return (
    <>
      <Navigation />
      <HeroSection />
      <TickerSection />
      <AboutSection />
      <SolutionsSection />
      <TrendsSection />
      <InnovationSection />
      <SustainabilitySection />
      <MarketsSection />
      <GallerySection />
      <WhySection />
      <ContactSection />
      <Footer />
    </>
  );
}
